import { forwardRef } from "react";
import React, { useId } from "react";
function SvgAiSparkWithGradient({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill={`url(#ai-spark-with-gradient_svg__a${toAppend})`}
        d="M22.857 17.714c.105 0 .197.07.225.172.883 3.197 1.549 3.863 4.746 4.746a.234.234 0 0 1 0 .45c-3.197.883-3.863 1.549-4.746 4.746a.234.234 0 0 1-.45 0c-.883-3.196-1.548-3.863-4.746-4.746a.234.234 0 0 1 0-.45c3.197-.883 3.863-1.549 4.746-4.746a.234.234 0 0 1 .225-.172Z"
      />
      <path
        fill={`url(#ai-spark-with-gradient_svg__b${toAppend})`}
        d="M13.429 4c.192 0 .362.128.413.315 1.62 5.86 2.838 7.081 8.701 8.7a.429.429 0 0 1 0 .827c-5.861 1.619-7.082 2.838-8.7 8.7a.429.429 0 0 1-.828 0c-1.619-5.86-2.838-7.081-8.701-8.7a.43.43 0 0 1 0-.827c5.862-1.619 7.082-2.838 8.701-8.7A.429.429 0 0 1 13.43 4Z"
      />
      <defs>
        <linearGradient
          id={`ai-spark-with-gradient_svg__a${toAppend}`}
          x1={28}
          x2={2.017}
          y1={20.25}
          y2={15.931}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#691C9C" />
          <stop offset={0.65} stopColor="#1F3CD7" />
          <stop offset={1} stopColor="#1088EB" />
        </linearGradient>
        <linearGradient
          id={`ai-spark-with-gradient_svg__b${toAppend}`}
          x1={28}
          x2={2.017}
          y1={20.25}
          y2={15.931}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#691C9C" />
          <stop offset={0.65} stopColor="#1F3CD7" />
          <stop offset={1} stopColor="#1088EB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgAiSparkWithGradient);
export default ForwardRef;
